import React from 'react';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { priority } from 'Constants/Database';
import { colors } from 'Constants/Colors';
import bytesToMegabytes from 'Utils/BytesToMegaBytes';
import useTranslation from 'Hooks/useTranslation';
import SelectIcon from './SelectIcon';
import SelectButton from './SelectButton';
import {
  ModalHeader,
  ModalContainer,
  ModalPhoto,
  ModalClose,
  ModalBottom,
  buttonStyle,
  ModalBody,
  ModalTitle,
  ModalText,
  DropzoneContainer,
  DropzoneArea,
  DropzoneText,
} from '../style';

export default function ModalDevelopment({
  title = '',
  text = '',
  close = () => {},
  priorityType = priority.Normativa,
  button1Event = () => {},
  button2Event = () => {},
  isLoading = false,
}) {
  const { t2 } = useTranslation('EmployeeAssess');
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
    accept: ['.docx', 'application/pdf', '.doc', '.mov', '.mp4'],
  });

  const acceptedFileItems = acceptedFiles.map(file => (
    <p key={file.path} style={{ textAlign: 'center' }}>
      {file.path} - {bytesToMegabytes(file.size)} MB
    </p>
  ));
  const isUpload = acceptedFileItems.length > 0;
  const fileRejectionItems = fileRejections.map(({ file }) => (
    <li key={file.path}>
      {file.path} - {bytesToMegabytes(file.size)} MB
    </li>
  ));

  return (
    <Paper>
      <ModalHeader>
        <ModalContainer>
          <ModalPhoto>
            <SelectIcon priorityType={priorityType} />
          </ModalPhoto>
        </ModalContainer>
        <ModalContainer>
          <ModalClose onClick={close}>
            <CloseIcon sx={{ fontSize: 30 }} style={{ color: colors.GRAY_DARK, fontWeight: 'bold' }} />
          </ModalClose>
        </ModalContainer>
      </ModalHeader>
      <ModalBody>
        <ModalTitle>{title}</ModalTitle>
        <ModalText>{text}</ModalText>
        {priorityType === priority.Tecnica ? (
          <DropzoneContainer>
            <DropzoneArea {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} />
              <CloudUploadIcon sx={{ fontSize: 80 }} style={{ color: colors.GREEN }} />
            </DropzoneArea>
            <DropzoneText>
              <p style={{ textAlign: 'center', color: colors.BLACK }}>
                {t2('UploadFiles')} <br />
                {t2('TypeFiles')}
              </p>
              <div style={{ margin: 'auto' }}>{acceptedFileItems}</div>
              {fileRejectionItems.length > 0 ? <h4 style={{ color: colors.RED }}>{t2('InvalidFormat')}</h4> : null}
            </DropzoneText>
          </DropzoneContainer>
        ) : null}
      </ModalBody>
      <ModalBottom>
        {priorityType !== priority.Normativa ? (
          <Button variant="outlined" style={buttonStyle(true)} onClick={button2Event}>
            {t2('Close')}{' '}
          </Button>
        ) : null}
        <SelectButton
          priorityType={priorityType}
          isUpload={isUpload}
          onClick={button1Event}
          acceptedFiles={acceptedFiles[0]}
          isLoading={isLoading}
        />
      </ModalBottom>
    </Paper>
  );
}
